export const SHOW_CREDITS = 'SHOW_CREDITS';

export function showCredits() {
  return {
    type: SHOW_CREDITS,
    show: true,
  };
}

export function hideCredits() {
  return {
    type: SHOW_CREDITS,
    show: false,
  };
}



// WEBPACK FOOTER //
// ./src/actions/credits.js